export default __webpack_public_path__ + "static/media/IkonNounCheckmark.0b62fa68.svg";